import React from "react";
import inputComponents from "./inputComponents";

class CombinedInput extends React.Component {
    state = { checked: true }
    componentWillMount() {
    }

    checkSettings(param) {
        if (this.props.settings) {
            return this.props.settings[param]
        } else {
            return false
        }
    }

    changeValue = (target, value, extra) => {
        let newValue = this.props.data != null ? this.props.data : false
        // newValue = !newValue

        // console.log('newwwwww',value);
        // console.log('newwwwww',target);
        // console.log('newwwwww',this.props.header.key);
        this.props.changeValue(target, value, extra)
    }

    render() {
        let information = this.props.header?.information
        // console.log('newwwwww',this.props.data);

        return (
            <div className={'row m-0 p-0 ' + this.props.inputClass}>
                {information.headers.map((header, index) => {
                    // console.log(header);
                    let key = header.key.split('.')[header.key.split('.').length - 1]
                    let Component = inputComponents[header.type]
                    let initData = this.props.data ?? {}
                    let data = initData[key]
                    let files
                    return (
                        <div className={' ' + (this.props.inputClass) + (index > 0 ? ' pld-2 ' : '')} style={{ flex: index + 1, backgroundColor: index == 1 ? '#00000010' : '' }}>
                            <Component ref={el => this["component-" + header.key] = el} header={header} data={data} files={files} changeFiles={this.changeFiles} changeValue={this.changeValue} setStatus={this.setStatus} variables={this.props.variables} optionsList={this.props.optionsList} width={this.props.width} />
                        </div>
                    )
                })}
            </div>
        );
    }
}

export default CombinedInput;
